function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Icon from "./icon";
import Button from "../elements/button";

var EmptyStateMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(EmptyStateMessage, _React$Component);

  var _super = _createSuper(EmptyStateMessage);

  function EmptyStateMessage() {
    _classCallCheck(this, EmptyStateMessage);

    return _super.apply(this, arguments);
  }

  _createClass(EmptyStateMessage, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--empty-state-message", this.props.className, "is-".concat(this.props.size))
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "et--empty-state-message--icon",
        icon: this.props.icon,
        iconKit: this.props.iconKit
      }), this.props.text ? /*#__PURE__*/React.createElement("div", {
        className: "et--empty-state-message--text"
      }, this.props.text) : undefined, this.props.subtext ? /*#__PURE__*/React.createElement("div", {
        className: "et--empty-state-message--subtext"
      }, this.props.subtext) : undefined, /*#__PURE__*/React.createElement("div", {
        className: "et--empty-state-message--content"
      }, this.props.children), /*#__PURE__*/React.createElement("div", {
        className: "et--empty-state-message--action-area",
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("div", null, this.props.actionLabel ? /*#__PURE__*/React.createElement("div", null, function () {
        if (_this.props.onAction) {
          return /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: _this.props.onAction
          }, _this.props.actionLabel);
        } else if (_this.props.actionLink) {
          return /*#__PURE__*/React.createElement("a", {
            className: "et--empty-state-message--action-button btn",
            href: _this.props.actionLink
          }, _this.props.actionLabel);
        }
      }()) : undefined), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: "20px"
        }
      }, this.props.actionButton ? this.props.actionButton : undefined)));
    }
  }]);

  return EmptyStateMessage;
}(React.Component);

_defineProperty(EmptyStateMessage, "displayName", "EmptyStateMessage");

_defineProperty(EmptyStateMessage, "propTypes", {
  icon: PropTypes.string,
  iconKit: PropTypes.string,
  text: PropTypes.node,
  subtext: PropTypes.node,
  size: PropTypes.oneOf(["small", "default", "page"]),
  actionLabel: PropTypes.any,
  actionLink: PropTypes.any,
  onAction: PropTypes.func,
  actionButton: PropTypes.any
});

_defineProperty(EmptyStateMessage, "defaultProps", {
  icon: "search",
  iconKit: "gt",
  size: "default"
});

export { EmptyStateMessage as default };